import { render, staticRenderFns } from "./ChatInboxSidebar.vue?vue&type=template&id=efc82976"
import script from "./ChatInboxSidebar.vue?vue&type=script&lang=js"
export * from "./ChatInboxSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports